export default "__VITE_ASSET__03vtIqxI__"